import { Box } from '@material-ui/core';
import { useState } from 'react';

import { useWidth } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/_shared/hooks/useWidth';
import { Action } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/types/PendingAction';
import { BnplPaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Bnpl/_shared/entities/PaymentMethodDetail/BnplPaymentMethodDetailEntity';
import { useLoanPaymentIntent } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/_shared/hooks/useLoanPaymentIntent';
import { CustomPaper } from '@/components/shared/components/CustomPaper';
import { FlexColumn } from '@/components/shared/components/FlexColumn';
import { Font } from '@/components/shared/components/Font';
import { StandardButton } from '@/components/shared/components/StandardButton';
import { Text } from '@/components/shared/components/Text';
import { useNotificationsContext } from '@/contexts/NotificationsContext/NotificationsContext';

interface NextActionCaptureOrderProps {
  paymentMethodDetailEntity: BnplPaymentMethodDetailEntity;
}

export const NextActionCaptureOrder = ({ paymentMethodDetailEntity }: NextActionCaptureOrderProps) => {
  const { selectedProvider } = paymentMethodDetailEntity;

  const {
    actions: { setSnackbarNotification },
  } = useNotificationsContext();

  const { updatePaymentMethodEntity } = useLoanPaymentIntent();
  const { width, ref } = useWidth<HTMLDivElement>();

  const [loading, setLoading] = useState(false);

  if (!selectedProvider) {
    return null;
  }

  const captureOrder = async () => {
    setLoading(true);
    try {
      await paymentMethodDetailEntity.captureOrder();
      updatePaymentMethodEntity(paymentMethodDetailEntity);
    } catch (error) {
      setSnackbarNotification({
        level: 'error',
      });
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <CustomPaper fill="grey.light">
      <div ref={ref}>
        <Box display="flex" flexDirection={width && width > 600 ? 'row' : 'column'} width="100%" gridGap={24}>
          <FlexColumn gridGap={4} flexGrow={1} minWidth={300}>
            <Font variant="body2" color="title" display="block">
              <Text strong tId={'CAPTURE_ORDER_TITLE'} />
            </Font>
            <Font variant="body2" color="title" display="block">
              <Text tId={'CAPTURE_ORDER_DESCRIPTION'} />
            </Font>
          </FlexColumn>
          <Box flexShrink={0} display="flex" alignItems="center">
            <StandardButton
              main
              size="small"
              disabled={!paymentMethodDetailEntity.orderCanBeCaptured() || loading}
              loading={loading}
              onClick={captureOrder}
            >
              <Text tId={Action.CAPTURE_ORDER} />
            </StandardButton>
          </Box>
        </Box>
      </div>
    </CustomPaper>
  );
};
